import { CustomComponentType, LiabilityCustomFieldKey } from '../../../../../enums';
import { PersonalFinancialTypeSelect } from '../personal-financial-type-select/personal-financial-type-select';
import { createSubaccountDefaultEditConfiguration } from '../configuration/default-edit-configuration';
import { convertOptionsToUseLabelAsValue } from '../../../../../utils/other-liabilities-utilities';

export class PersonalLiabilityTypeSelect extends PersonalFinancialTypeSelect {
	static schema(...extend: any) {
		return PersonalFinancialTypeSelect.schema(
			{
				label: 'Liability Type',
				type: CustomComponentType.personalLiabilityTypeSelect,
				key: LiabilityCustomFieldKey.LiabilityType
			},
			...extend
		);
	}

	static editForm = createSubaccountDefaultEditConfiguration(CustomComponentType.personalLiabilityTypeSelectOptions);

	static get builderInfo() {
		return {
			title: 'Liability Type',
			weight: 10,
			schema: PersonalLiabilityTypeSelect.schema()
		};
	}

	setItems(items: any, fromSearch: boolean): void {
		let massagedItems = items;
		if (items && Array.isArray(items)) {
			massagedItems = items.filter(option => option.enabledForConsumers);
			// Change massagedItems to use the label for the value as well
			// For Other Liabilities, it was showing the default values in the preview row.
			// The cause was that the default values were being used for the values of the options
			// and the custom options were being used for the labels.
			massagedItems = convertOptionsToUseLabelAsValue(massagedItems);
		}
		super.setItems(massagedItems, fromSearch);
	}
}
